import QrCodeImg from "../../../assets/qr/mobile-app.png"
import PopUpNotification from "../pop-up-notification"
import { APP_DOWNLOAD_LINK } from "../../constants"

const MobileAppPopup = () => (
  <PopUpNotification id="mobile-app">
    <div className="relative text-center py-3 bg-[#E8E4F3]">
      <div className="absolute top-[53px] -left-6 transform -rotate-45 origin-top-left">
        <div className="bg-violet-500 text-white text-sm h-[22px] w-28 leading-[22px] font-medium">
          <span className="relative left-[-2px]">NEW</span>
        </div>
      </div>

      <img
        className="w-[137px] inline-block"
        src={QrCodeImg}
        alt="QR code to download mobile app"
      />
    </div>
    <div className="py-3 px-6">
      <h2 className="text-xl font-serif font-semibold text-base-dark m-0">
        Download Mobile App
      </h2>
      <p className="text-base text-base-dark m-0 pt-1">
        Your Mortgage Lead Command Center—Now in Your Pocket
      </p>
      <a
        className="inline-block mt-3 text-lg font-semibold text-primary-400 hover:text-primary-500 border-b border-dashed border-primary-400 hover:border-primary-500 pb-px"
        target="_blank"
        rel="noopener noreferrer"
        href={APP_DOWNLOAD_LINK}
      >
        Download Now
      </a>
    </div>
  </PopUpNotification>
)

export default MobileAppPopup
